import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MyGolfStorageService } from '../../storage/mygolf-storage.service';
import { catchError, map } from 'rxjs/operators';
import { Custom_RequestMethod } from '../common-service';
import { RemoteHttpService } from 'src/remote-http';
import * as moment from 'moment';
/**
 * Created by ashok on 22/04/17.
 */

@Injectable()
export class EventLogService {
  constructor(
    private mygolfStorage: MyGolfStorageService,
    private http: RemoteHttpService,
    private requestMethod: Custom_RequestMethod
  ) {}
  public writeEvent(
    category: string,
    title: string,
    message: string,
    eventType: string = 'info',
    extra?: string
  ) {
    let eventLog = {
      category: category,
      type: eventType,
      time: Date.now(),
      title: title,
      message: message,
      extra: extra,
      eventDate: moment().format('YYYY-MM-DD'),
      eventTime: moment().format('HH:mm:ss'),
    };
    this.mygolfStorage.getPreference('event_logs').subscribe(
      (value: Array<any>) => {
        if (value) value.unshift(eventLog);
        else {
          value = [eventLog];
        }
        this.mygolfStorage.setPreference('event_logs', value);
      },
      error => {
        this.mygolfStorage.setPreference('event_logs', [eventLog]);
      }
    );
  }
  public listEvents(): Observable<Array<any>> {
    return this.mygolfStorage
      .getPreference('event_logs')
      .pipe(
        map((events: Array<any>) => {
          if (events) {
            events.forEach(event => {
              event.time = new Date(event.time);
            });
          }
          return events;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
  public clearAllEvents(): Observable<boolean> {
    return this.mygolfStorage.setPreference('event_logs', []).pipe(
      map(() => {
        return true;
      })
    );
  }
  public deleteEvent(index: number): Observable<boolean> {
    return this.mygolfStorage
      .getPreference('event_logs')
      .pipe(
        map((value: Array<any>) => {
          if (value && value.length > index) {
            let newLogs = value.slice(0, index);
            if (index + 1 < value.length) newLogs.push(...value.slice(index + 1));
            this.mygolfStorage.setPreference('event_logs', newLogs);
            return true;
          } else return true;
        })
      )
      .pipe(catchError(this.http.handleError));
  }
}
